import { Circle, ExpandMore } from '@mui/icons-material'
import { AccordionSummary, Grid, Typography } from '@mui/material'

import useStyles from '../index.styles'

const SummaryTopLevel = ({ label, count, hasAlert, icon }: { label: string; count: number; hasAlert: boolean; icon?: React.ReactNode }) => {
  const classes = useStyles
  return (
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Grid container={true} size={12} sx={[classes.accordionSummaryGrid, { paddingLeft: 0 }]}>
        <Grid container={true} sx={classes.accordionSummaryContent}>
          {icon}
          <Typography component="span" variant="subtitle1" sx={classes.boldText500}>
            {label}
          </Typography>
        </Grid>
        <Grid container={true} sx={classes.accordionSummaryContent}>
          {hasAlert && <Circle sx={classes.alertCircle} aria-label="There are alerts" />}
          <Typography variant="body2" sx={classes.boldText500}>
            ({count})
          </Typography>
        </Grid>
      </Grid>
    </AccordionSummary>
  )
}

const SummaryNested = ({ label, count, icon }: { label: string; count: number; icon?: React.ReactNode }) => {
  const classes = useStyles
  return (
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Grid container={true} size={12} sx={classes.accordionSummaryGrid}>
        <Grid container={true} sx={classes.accordionSummaryContent}>
          {icon}
          <Typography component="span" variant="subtitle1" sx={classes.boldText500}>
            {label}
          </Typography>
        </Grid>
        <Typography variant="body2" sx={classes.boldText500}>
          ({count})
        </Typography>
      </Grid>
    </AccordionSummary>
  )
}

const AccordionGroup = {
  SummaryTopLevel,
  SummaryNested,
}

export default AccordionGroup
